import { Trans } from "@lingui/react/macro";
import { observer } from "mobx-react-lite";
import { useState } from "react";

import { AppModel } from "../../../app/app-model";
import { RequiredAsterisk } from "../../../components/ui-kit/required-asterisk";
import { AddTable } from "../../../components/ui-kit/tables/add-table";
import { CellDateInput } from "../../../components/ui-kit/tables/cell-fields/cell-date-input";
import { CellTextInput } from "../../../components/ui-kit/tables/cell-fields/cell-text-input";
import { AddRHC } from "./add-rhc";

export const AddRHCTable = observer(function AddRHCTable(props: {
  app: AppModel;
}) {
  const patient = props.app.requirePatient();
  const [model] = useState(() => {
    const m = new AddRHC(patient.api, patient);
    void m.initEmpty();
    return m;
  });

  return (
    <AddTable
      model={model}
      canAddRows={false}
      setAllDates="datetime"
      columns={[
        {
          header: <Trans>Measured at</Trans>,
          cell: (item) => (
            <CellDateInput
              attr="measurement_datetime"
              model={item}
              type="datetime-local"
            />
          ),
        },
        {
          header: <Trans>Type</Trans>,
          cell: (item) => (
            <label>
              {item.measurement_type.charAt(0).toUpperCase() +
                item.measurement_type.slice(1)}
            </label>
          ),
        },
        {
          header: <Trans>Required</Trans>,
          cell: (item) => (
            <>
              {model.requiredEitherOr.includes(item.measurement_type) ? (
                <RequiredAsterisk />
              ) : (
                <span
                  className={
                    model.required.includes(item.measurement_type)
                      ? "text-brand-primary"
                      : "text-2xs"
                  }
                >
                  {model.required.includes(item.measurement_type) ? (
                    <Trans>Yes</Trans>
                  ) : (
                    <Trans>No</Trans>
                  )}
                </span>
              )}
            </>
          ),
        },
        {
          header: <Trans>Value</Trans>,
          cell: (item) => (
            <CellTextInput attr="measurement_value" model={item} />
          ),
        },
        {
          header: <Trans>Unit</Trans>,
          cell: (item) => <label>{item.measurement_unit}</label>,
        },
        {
          header: <Trans>Comment</Trans>,
          cell: (item) => (
            <CellTextInput attr="comment" model={item} multiline="autosize" />
          ),
        },
      ]}
      footer={
        <span>
          <Trans>
            <RequiredAsterisk /> = either Fick or TD required, you can enter
            both measurements
          </Trans>
        </span>
      }
    />
  );
});
